<hk-base-modal [hideApplyButton]="true" [hideCancelButton]="true">
  <div class="flex flex-1 items-center gap-4 !font-normal" titleContent>
    <div class="flex items-center gap-1">
      <hk-search-field
        (searchValueChange)="search($event)"
        [(searchValue)]="searchString"
        [placeholder]="'Search'"
        class="w-[320px]"
      ></hk-search-field>
      <button
        (click)="findPrevious()"
        [disabled]="searchString.length === 0 || numMatches === 0"
        [matTooltip]="'common.previous' | translate"
        hk-button-stroked
        matTooltipTouchGestures="off"
      >
        <i class="ph ph-caret-left"></i>
      </button>
      <button
        (click)="findNext()"
        [disabled]="searchString.length === 0 || numMatches === 0"
        [matTooltip]="'common.next' | translate"
        hk-button-stroked
        matTooltipTouchGestures="off"
      >
        <i class="ph ph-caret-right"></i>
      </button>
      <div *ngIf="searchString.length > 0">({{ selectedMatchCount }}/{{ numMatches }})</div>
    </div>
    <div class="flex flex-1"></div>
    <div class="flex items-center gap-1">
      <ng-select
        (change)="zoomMode = $event"
        [(ngModel)]="zoomMode"
        [clearable]="false"
        [closeOnSelect]="true"
        [items]="availableZoomModes"
        [searchable]="false"
        appendTo="body"
        class="flex-0 ng-select-in-overlay basis-[100px]"
        placeholder="Zoom"
      >
        <ng-template let-item="item" ng-label-tmp ng-option-tmp>
          {{ 'pdfViewer.zoomModes.' + item | translate }}
        </ng-template>
      </ng-select>
      <button (click)="zoom = zoom * 1.2" [matTooltip]="'visu.zoomInTooltip' | translate" hk-button-stroked matTooltipTouchGestures="off">
        <i class="ph ph-plus"></i>
      </button>
      <button
        (click)="zoom = zoom / 1.2"
        [matTooltip]="'visu.zoomOutTooltip' | translate"
        class="icon-button"
        hk-button-stroked
        matTooltipTouchGestures="off"
      >
        <i class="ph ph-minus"></i>
      </button>
      <button
        (click)="zoom = 1.0"
        [matTooltip]="'visu.resetZoomTooltip' | translate"
        class="icon-button"
        hk-button-stroked
        matTooltipTouchGestures="off"
      >
        <i class="ph ph-arrows-out"></i>
      </button>
    </div>
    <div class="mr-4 flex items-center gap-1">
      <button
        (click)="print()"
        [matTooltip]="'common.print' | translate"
        class="icon-button"
        hk-button-stroked
        matTooltipTouchGestures="off"
      >
        <i class="ph ph-printer"></i>
      </button>
      <button
        (click)="data.download()"
        [matTooltip]="'common.download' | translate"
        class="icon-button"
        color="primary"
        hk-button-stroked
        matTooltipTouchGestures="off"
      >
        <i class="ph ph-download-simple"></i>
      </button>
    </div>
  </div>
  <div class="flex flex-1 flex-col overflow-y-hidden">
    <mat-divider></mat-divider>
    <div class="relative flex flex-1 bg-hk_gray-600">
      <pdf-viewer
        (after-load-complete)="onAfterLoadCompleted($event)"
        [ngClass]="{ noMarginBottomOnPages: numPages === 1 && zoomMode !== 'page-width' }"
        [original-size]="false"
        [render-text]="true"
        [src]="docSrc ?? ''"
        [zoom-scale]="$any(zoomMode)"
        [zoom]="zoom"
        class="flex-1 overflow-y-hidden"
      ></pdf-viewer>
      <hk-centered-mat-spinner *ngIf="showSpinner" data-testid="reportViewer.loadingSpinner"></hk-centered-mat-spinner>
    </div>
  </div>
</hk-base-modal>
